//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CalendarColorMode, CalendarViewMode, StudentPortalHomepage } from './Enums';

export class SchoolStudentPortalSettingsDisplayItem extends ItemBase {
    AllowPartialOnlinePayments: boolean = false;
    AllowProfileEditing: boolean = false;
    CanSetTimeZone: boolean = false;
    CalendarColorMode: CalendarColorMode = CalendarColorMode.EventCategory;
    InitialCalendarView: CalendarViewMode = CalendarViewMode.Day;
    InitialView: StudentPortalHomepage = StudentPortalHomepage.Calendar;
    ShowAccountAndInvoices: boolean = false;
    ShowMakeupCredits: boolean = false;
    ShowStudentAttendeeList: boolean = false;
    ShowStudentContactList: boolean = false;
    ShowTeacherAddress: boolean = false;
    ShowTeacherEmailAndTelephoneNumber: boolean = false;

    constructor(initializer?: Partial<SchoolStudentPortalSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolStudentPortalSettingsDisplayItem";
}
